import { LoggedInQuery } from 'graph/LoggedInQuery'
import { Site } from 'graph/Site'
import { createContext } from 'react'

export type ViewerContextType = Site['viewer'] | LoggedInQuery['viewer']
export type User = ViewerContextType['user']

// @ts-ignore
export const ViewerContext = createContext<ViewerContextType>(null)

ViewerContext.displayName = 'ViewerContext'
